import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { automationQueryKeys } from "./automationQueryKeys";

export function useAutomationEditBcc({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      automationId,
      bccList,
    }: {
      automationId: number;
      bccList: string[];
    }) => {
      await api.automationApi.updateBCC(automationId, bccList);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: automationQueryKeys.all() });
    },
  });
}
